import React from 'react';

import { Title } from '../../atoms';

const rederVertical = props => {
	return(
		<div className={`label-with-color ${props.small ? "-small" : ""}`}>
			<div className="label">{props.label}</div>
			<div className="circle" style={props.style} />
		</div>
	);
};

const rederHorizontal = props => {
	return(
		<div className={`label-with-color -horizontal ${props.small ? "-small" : ""}`}>
			<div className="circle" style={props.style} />
			<div className="label">{props.label}</div>
		</div>
	);
};

export const LabelWithColor = props => {

	return props.horizontal ? rederHorizontal(props) : rederVertical(props);
};


// WEBPACK FOOTER //
// src/molecules/lib/LabelWithColor.js